import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, reactive, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      for (let i = 0;; i++) {
        if (text.indexOf("{{") == -1) break;
        let questionNum = `<span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu + i}</span>________`;
        text = text.substring(0, text.indexOf("{{")) + questionNum + text.substr(text.indexOf("}}") + 2);
      }
      return text;
    });
    //答案
    let answer = reactive({});
    let route = useRoute();
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          if (questionGroup.questionMethod == "mcq" || questionGroup.questionMethod == "judge") {
            list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
          } else if (questionGroup.questionMethod == "mmcq") {
            list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId].split(",") : [];
          }
        });
      });
      for (let key in answer) {
        delete answer[key];
      }
      Object.assign(answer, list);
      setAnswer();
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question")[0].scrollTop = 0;
      if (route.meta.skill == "S0") setAnswer();
    });
    onMounted(() => {
      if (route.meta.skill == "S0") setAnswer();
    });
    function setAnswer() {
      let data = {};
      for (let key in answer) {
        if (answer[key] instanceof Array) {
          data[key] = answer[key].join(",");
        } else {
          data[key] = answer[key];
        }
      }
      content.emit("setAnswer", data);
    }
    return {
      itemText,
      answer,
      setAnswer
    };
  }
};